/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, ContactTitle } from "../../Constant";
import { useAppDispatch } from "../../Redux-Toolkit/Hooks";
import { setUsers } from "../../Redux-Toolkit/Reducers/ContactSlice";
import { ContactApi } from "../../api";
import ContactSideBar from "./ContactSideBar";
import TabComponent from "./TabComponent";
import { toast, ToastContainer } from "react-toastify";

const ContactsContainer = () => {
  const [activeTab, setActiveTab] = useState("2");
  const dispatch = useAppDispatch();
  const getUsers = async () => {
    try {
      await axios.get(ContactApi).then((resp) => {
        dispatch(setUsers(resp.data));
      });
    } catch (error) {
      toast.error("error" + error);
    }
  };
  useEffect(() => {
    getUsers();
  }, []);

  const callback = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={ContactTitle} parent={Apps} title={ContactTitle} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <Col xl="3" className="box-col-4e">
              <ContactSideBar callback={callback} />
            </Col>
            <Col xl="9" md="12" className="box-col-8">
              <TabComponent activeTab={activeTab} />
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Container>
    </>
  );
};

export default ContactsContainer;
